import { setupListeners } from "@reduxjs/toolkit/query";
import { configureStoreOptions } from "sb-material-components";
import { configureStore } from "@reduxjs/toolkit";
import { apiBase } from "./services/apiBase";

export const createStore = () =>
    configureStore(
        configureStoreOptions([
            {
                apiReducerPath: apiBase.reducerPath,
                apiReducer: apiBase.reducer,
                apiMiddleware: apiBase.middleware,
            },
        ]),
    );

export const store = createStore();

setupListeners(store.dispatch);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
